import { render } from "./RegistrationConfirmation.vue?vue&type=template&id=78d1f0a5&scoped=true"
const script = {}

import "./RegistrationConfirmation.vue?vue&type=style&index=0&id=78d1f0a5&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d1f0a5"]])

export default __exports__